import React from 'react';
import { Icons } from './svgs';
import { cn } from '../../utils/helper';

const CheckBox = React.forwardRef(({ id, className, IconClassName, checked, ...props }, ref) => {
  return (
    <label htmlFor={id} className="flex gap-2 relative">
      <input
        ref={ref}
        type="checkbox"
        id={id}
        className={cn(
          'relative peer shrink-0 appearance-none w-[21px] h-[21px] border-[1.5px] border-expert-lightBlack rounded-sm',
          className
        )}
        checked={checked}
        {...props}
      />
      <Icons.checkBoxTick
        className={cn(
          'w-4 h-4 absolute top-[10%] left-1/2 transform -translate-x-1/2  hidden peer-checked:block cursor-pointer',
          IconClassName,
          {
            block: checked
          }
        )}
      />
    </label>
  );
});

CheckBox.displayName = 'CheckBox';

export default CheckBox;
